import { useMediaQuery } from '@vueuse/core';

export const useDeviceType = () => {
  const isDesktop = useMediaQuery('(width >= 48rem)');
  const isMobile = useMediaQuery('(width < 48rem)');

  return { isDesktop, isMobile };
};
